<template>
  <div class="chart-container">
    <Doughnut :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
  name: 'DonutChart',
  components: { Doughnut },
  props: {
    totalSales: {
      type: Number,
      required: true
    },
    salesTarget: {
      type: Number,
      required: true
    },
    height: {
      type: [Number, String],
      default: 200
    }
  },
  computed: {
    chartData() {
      const achieved = Math.min(this.totalSales, this.salesTarget);
      const remaining = Math.max(this.salesTarget - this.totalSales, 0);
      return {
        labels: ['Achieved', 'Remaining'],
        datasets: [
          {
            data: [achieved, remaining],
            backgroundColor: ['#36A2EB', '#E0E0E0'],
            borderColor: ['#36A2EB', '#E0E0E0'],
            borderWidth: 1
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false // Disable the legend to remove "Achieved" and "Remaining" labels
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                const label = context.label || '';
                const value = context.raw || 0;
                return `${label}: $${value.toFixed(2)}`;
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: v-bind(height + 'px');
  width: 100%;
}
</style>